import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Logo from '../assets/img/dr-mario-arcila-logo.webp'
import Main from '../components/Hardcoded/Main'
    

function MainPage() {
  return (
    <div>
        <Header logoSrc={Logo}/>
        <Main />
        <Footer logoSrc={Logo}/>
    </div>
  );
}

export default MainPage;
